import { jsx as _jsx } from "react/jsx-runtime";
import frownIcon from '@jetbrains/icons/frown';
import NotFoundError from '@common/errors/not-found-error';
import styles from './error-page.css';
export function UnknownErrorPage(props) {
    return (_jsx(NotFoundError, { className: styles.errorPage, fallbackHref: "/", "data-test": "something-went-wrong", fallbackMessage: "Navigate to home page", message: "Oops! Something went wrong", icon: frownIcon, ...props }));
}
